<template>
  <div class="container">
    <titular />
    <div class="row mb-4">
      <div class="col-12 col-md-6 col-lg-4 mx-auto">
        <label for="proyecto">Afegir projecte</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-archive" title="Projecte" v-tooltip></i></div>
          </div>
          <input list="proyectos" class="form-control" autocomplete="off" id="proyecto" v-model="proyecto" @input="anyadirProyecto" :disabled="loading.anyadirProyecto" />
        </div>
        <datalist id="proyectos">
          <option v-for="(proyecto, index) in proyectos" :key="index">{{ getProyectoValue(proyecto.titol, proyecto.cliente) }}</option>
        </datalist>
      </div>
    </div>
    <template v-if="proyectosAnyadidos.length">
      <div class="row mb-3">
        <div class="col-12">
          <ul class="list-inline">
            <li class="list-inline-item">
              <button class="btn btn-primary" @click="exportarFilas" :disabled="loading.download"><i class="fa-solid fa-download"></i> Exportar en arxiu</button>
            </li>
            <li class="list-inline-item">
              <button class="btn btn-secondary" @click="proyectosAnyadidos = []"><i class="fa-solid fa-eraser"></i> Esborrar llistat</button>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-sm table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">{{ columnas[0] }}</th>
                  <th scope="col">{{ columnas[1] }}</th>
                  <th scope="col" class="text-center">{{ columnas[2] }}</th>
                  <th scope="col" class="text-center">{{ columnas[3] }}</th>
                  <th scope="col" colspan="2" class="text-center">{{ columnas[4] }}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(proyecto, index) in proyectosAnyadidos" :key="index">
                  <th class="align-middle" scope="row">
                    <router-link v-if="proyecto.es_actiu" :to="{ path: '/recursos-projecte', query: { id: proyecto.id, filtre: 'tot' } }" target="_blank">{{ proyecto.titol }}</router-link>
                    <span v-else>{{ proyecto.titol }}</span>
                  </th>
                  <td class="align-middle">{{ proyecto.cliente }}</td>
                  <td class="text-center align-middle" v-html="proyecto.prevision.total_presupuesto ? `${Math.round(proyecto.prevision.total_presupuesto)}€` : '-'" :title="proyecto.codi_pressupost" v-tooltip></td>
                  <td class="text-center align-middle" v-html="proyecto.prevision.totales_costes.realidad ? `${Math.round(proyecto.prevision.totales_costes.realidad)}€` : '-'"></td>
                  <td class="text-center align-middle">
                    <span v-if="proyecto.prevision.total_presupuesto" :class="{ 'text-danger': proyecto.prevision.margenCalculado < 0 }">{{ Math.round(proyecto.prevision.margeReal) }}€</span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-center align-middle">
                    <span v-if="proyecto.prevision.total_presupuesto" :class="{ 'text-danger': proyecto.prevision.margenCalculado < 0 }">{{ proyecto.prevision.margenCalculado }}%</span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-center align-middle">
                    <button ref="tooltips" class="btn btn-outline-danger btn-sm" title="Eliminar fila" v-tooltip:left @click="eliminarFila(index)"><i class="fa-solid fa-trash-can"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <vacio>Utilitza el formulari superior per llistar projectes.</vacio>
    </template>
  </div>
</template>
        
<script>
export default {
  name: "MargeProjectes",
  data() {
    return {
      loading: {
        anyadirProyecto: false,
        download: false,
      },
      proyectos: [],
      proyectosAnyadidos: [],
      proyecto: "",
      columnas: ["Projecte", "Client", "Pressupost", "Cost", "Marge", "Marge %", "Responsable"],
    };
  },
  mounted() {
    this.$http.get("api/projectes?order=cliente").then((response) => {
      this.proyectos = response.data;
    });
  },
  methods: {
    eliminarFila(index) {
      this.$refs.tooltips.forEach((element) => $(element).tooltip("dispose"));

      this.proyectosAnyadidos.splice(index, 1);
    },
    anyadirProyecto() {
      if (!this.proyecto.length) return;

      const index = this.proyectos.findIndex(a => this.getProyectoValue(a.titol, a.cliente).replace(/\s+/g, ' ').trim() == this.proyecto.replace(/\s+/g, ' ').trim());

      if (index == -1) return;

      this.loading.anyadirProyecto = true;
      this.proyecto = "";

      const proyecto = this.proyectos[index];

      this.$http.get(`api/projectes/${proyecto.id}?prevision`)
        .then((response) => {
          proyecto.prevision = response.data;
          proyecto.prevision.total_presupuesto = Math.round(proyecto.prevision.totales_costes.prevision) / (1 - (Math.round(proyecto.prevision.margen_prevision) / 100));
          proyecto.prevision.margeReal = proyecto.prevision.total_presupuesto - (proyecto.prevision.totales_costes.realidad ?? 0);
          proyecto.prevision.margenCalculado = Math.round((proyecto.prevision.margeReal / proyecto.prevision.total_presupuesto) * 100);

          this.proyectosAnyadidos.unshift(proyecto);
          this.proyectos.splice(index, 1);
        })
        .finally(() => this.loading.anyadirProyecto = false);
    },
    getProyectoValue(titulo, cliente) {
      return `${cliente} → ${titulo}`;
    },
    exportarFilas() {
      this.loading.download = true;
      let separador = ";";
      let exportacion_filas = [this.columnas.join(separador).toUpperCase()];

      this.proyectosAnyadidos.forEach(proyecto => exportacion_filas.push([
        proyecto.titol,
        proyecto.cliente,
        Math.round(proyecto.prevision.total_presupuesto),
        Math.round(proyecto.prevision.totales_costes.realidad),
        proyecto.prevision.total_presupuesto ? Math.round(proyecto.prevision.margeReal) : "",
        proyecto.prevision.total_presupuesto ? proyecto.prevision.margenCalculado : "",
        proyecto.trabajador,
      ].join(separador)));

      const link = document.createElement("a");
      link.href = URL.createObjectURL(new Blob(["\ufeff", exportacion_filas.join("\n")], { type: "text/csv;charset=utf-8;" }));
      link.download = "marge_projectes.csv";
      link.click();

      this.loading.download = false;
    },
  },
};
</script>